<section>
  <div class="p-row">
    <h1 class="page-header">{{ 'MOUNTING.TRACE_MATERIAL_TITLE' | translate }}</h1>
    <app-trace-material-table [tableData]="tableData" [loading]="isLoading" [buttonTemplate]="buttonTemplate"></app-trace-material-table>
  </div>
</section>

<ng-template #buttonTemplate let-rowData>
  <ng-container *ngIf="rowData.displayMode === MaterialTableDataRowDisplayMode.BillOfMaterial; else batchButton">
    <lib-split-button class="overview__action" [items]="constructButtons(rowData)"></lib-split-button>
  </ng-container>
  <ng-template #batchButton>
    <lib-dismount-button
      [loadingTopic]="LOADING_TOPIC + rowData.mountedMaterialId"
      (buttonClicked)="unassignTraceMaterial(rowData.mountedMaterialId)"
    ></lib-dismount-button>
  </ng-template>
</ng-template>
